export const ACCOUNT_TYPE_PREVIEW_ROUTE = 'account-type-preview';
export const EMAIL_ACTIVATE_ROUTE = 'activate-email';
export const EMAIL_SENT_ROUTE = 'sent-email';
export const OWNER_DETAILS_ROUTE = 'owner-details';
export const CLAIM_ACCOUNT_ROUTE = 'account/claim-account';
export const OWNER_ADDRESSES_ROUTE = 'owner-address';
export const MEMBERSHIP_OPTIONS_ROUTE = 'membership-options';
// Marks claim-pet and the pet confirm page as the add pet flow, so saving the new pet goes on to the steps after pet details
export const ADD_PET_QUERY_PARAM = 'addPet';
// The pet claimed in the add pet flow, so its confirm page and the welcome gift still know it after the
// keeper leaves the flow or pays for a plan
export const ADD_PET_ID_STORAGE_KEY = 'addPetFlowPetId';
export const IDENTIBASE_SUBSCRIBE_APPRECIATION_ROUTE = 'identibase-subscribe-appreciation';
export const ACTIVATE_NO_EMAIL_USER_ROUTE = 'account/activate-no-email-user';
export const QR_CODE_ROUTE = 'qr-code';
export const QR_CODE_PREFERENCES_ROUTE = 'qr-code-preferences';
export const LOGIN_REGISTER_ROUTE = 'login-register';
export const TOK_CLAIM_ACCOUNT = 'tok-claim-account';
export const TOK_LOGIN = 'tok-login';
export const TOK_PAYMENT = 'tok-payment';
export const TOK_DETAILS = 'tok-details';
